import Modal from "./Modal";

import Calls from "../ui/Calls";

const CallsModal = ({ filter, open, onClose, onRefresh }) => {
  return (
    <Modal
      title="Calls"
      open={open}
      onClose={onClose}
    >
      <Calls
        filter={filter}
        onRefresh={onRefresh}
      />
    </Modal>
  );
};

export default CallsModal;
